import { render } from "./BurgerMenu.vue?vue&type=template&id=531c3289&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=531c3289&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531c3289"]])

export default __exports__